var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',{attrs:{"label":_vm.label}},[_c('datetime',{attrs:{"id":"date-start","format":"MM/DD/YYYY"},model:{value:(_vm.date.date),callback:function ($$v) {_vm.$set(_vm.date, "date", $$v)},expression:"date.date"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }